import React, { useState } from "react";
import styled from "styled-components";

import { Link } from "gatsby";
import { useQuery } from "styles/breakpoints";
import { blueDark, textWhite, lightGrey } from "styles/colors";

import { ExtraSmallParagraph, FlexWrapper, Svg } from "components";

const NAVIGATION_DATA = [
  {
    id: 1,
    url: "/",
    text: "FAQ",
  },
  {
    id: 2,
    url: "/",
    text: "Contacts",
  },
  {
    id: 3,
    url: "/",
    text: "Privacy Policy",
  },
  {
    id: 4,
    url: "/",
    text: "Terms & Conditions",
  },
];

export const Navigation: React.FC = () => {
  const [isNavigationOpen, setIsNavigationOpen] = useState(false);
  const { isTablet } = useQuery();

  const toggleNavbar = () => {
    setIsNavigationOpen((previousState) => !previousState);
  };

  const renderElement = isTablet ? (
    <>
      <SvgWrapper isOpen={isNavigationOpen} onClick={toggleNavbar}>
        <Svg src='bars_icon' />
      </SvgWrapper>
      <MobileNavigation isOpen={isNavigationOpen}>
        {NAVIGATION_DATA.map(({ id, url, text }) => (
          <LinkMobile key={id} to={url}>
            {text}
          </LinkMobile>
        ))}
      </MobileNavigation>
    </>
  ) : (
    <FlexWrapper>
      {NAVIGATION_DATA.map(({ id, url, text }) => (
        <LinkDekstop key={id} to={url}>
          <ExtraSmallParagraph>{text}</ExtraSmallParagraph>
        </LinkDekstop>
      ))}
    </FlexWrapper>
  );

  return renderElement;
};

const MobileNavigation = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 4rem;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${blueDark};
  transition: 0.3s;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  z-index: 1;
  pointer-events: ${({ isOpen }) => (isOpen ? 'all' : 'none')};
`;

const LinkStyled = styled(Link)`
  color: ${textWhite};
  text-decoration: none;
  transition: 0.3s;

  &:hover {
    transform: scale(0.96);
  }
`;

const LinkDekstop = styled(LinkStyled)`
  margin-left: 2rem;
`;

const LinkMobile = styled(LinkStyled)`
  padding: 1rem 0;
  border-bottom: 3px solid ${lightGrey};
  text-align: center;
`;

const SvgWrapper = styled.div<{ isOpen: boolean }>`
  transition: 0.3s;
  cursor: pointer;
  z-index: 1;
  ${({ isOpen }) => isOpen && `transform: rotate(90deg);`};

  &:hover {
    ${({ isOpen }) =>
      isOpen ? `transform: rotate(90deg);` : `transform: scale(0.98);`};
  }
`;